// extracted by mini-css-extract-plugin
export var divider = "_rb-0";
export var systemMessage = "_rb-1";
export var systemMessageWrapper = "_rb-2";